/* global fetch, Request */

import { register, getPrefix, applyAll, apply } from '../../../Utils'

const FilterList = el => {
  const prefix = getPrefix(el)
  const filterItems = el.querySelectorAll(`.${prefix}click-item`)
  let loadMoreButton = el.querySelector(`.${prefix}click-item-load-more`)
  const resultContainer = el.querySelector(`.${prefix}result-container`)

  const clickItem = e => {
    el.classList.add(`${prefix}is--loading`)

    fetch(new Request(e.target.dataset.linkFilters, {
      method: 'GET',
      cache: 'no-cache',
      mode: 'no-cors' // change
    }))
      .then(response => response.text() // check if direct ret ok
        .then(text => {
          const listWrapper = document.querySelector('#filterListWrapper')
          el.classList.remove(`${prefix}is--loading`)
          el.outerHTML = text
          applyAll(listWrapper)
          el = null
        })
      )
      .catch(error => {
        console.log('Request failed: ', error)
      })
  }

  const clickLoadMore = e => {
    el.classList.add(`${prefix}is--loading`)

    fetch(new Request(e.target.dataset.link, {
      method: 'GET',
      cache: 'no-cache',
      mode: 'no-cors' // change
    }))
      .then(response => response.text() // check if direct ret ok
        .then(text => {
          el.classList.remove(`${prefix}is--loading`)
          loadMoreButton.remove()
          const newContent = document.createElement('div')
          newContent.innerHTML = text
          resultContainer.appendChild(newContent)

          loadMoreButton = resultContainer.querySelector(`.click-item-load-more`)
          if (loadMoreButton) {
            loadMoreButton.addEventListener('click', clickLoadMore)
          }
        })
      )
      .catch(error => {
        console.log('Request failed: ', error)
      })
  }

  filterItems.forEach(item => {
    item.addEventListener('click', clickItem)
  })

  loadMoreButton.addEventListener('click', clickLoadMore)
}

register('FilterList', FilterList)
